module.exports = __webpack_public_path__ + "img/tricky.42c018b7.jpg";